import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shell/page-header';
import { snipeCallersQuery, snipesQuery } from '@/features/calls/calls-api';
import { SnipeScreen } from '@/features/calls/snipe-screen';

export const Route = createFileRoute('/_app/snipe')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(snipeCallersQuery);
    void queryClient.prefetchQuery(snipesQuery);
  },
  component: () => (
    <>
      <PageHeader title="Snipe" />
      <SnipeScreen />
    </>
  ),
});
